import styled from "@emotion/styled";


interface ModalContentStyle {
  background?: string;
  zIndex?: number;
}

export const ModalContent = styled.div`
  position: fixed;
  max-width: 100%;
  background: ${({ background }: ModalContentStyle) => background};
  z-index: ${({ zIndex }: ModalContentStyle) => zIndex};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  
  &.partial-modal {
    top: 50%;
    left: 50%;
    width: 100%;
    transform: translate(-50%, -50%);
     height: auto;
  }
  
  &.error-modal {
    max-width: 300px;
    border-radius: 2px;
  }
  
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
   z-index: ${({ zIndex }: ModalContentStyle) => zIndex};

  .hide-overlay {
    z-index: 1;
    background-color: rgba(0, 0, 0, 0);
  }
`;
